import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import { sortList } from '~/Context/Global';

import createQuill from '~/Components/Quill/Quill';

import Toolbar from '~/Containers/Pages/Lists/Toolbar';
import RecoveryModeBanner from '~/Components/Pages/Lists/RecoveryModeBanner';

import SkinWrapper from '~/Containers/Layout/SkinWrapper/SkinWrapper';
import DateTabs from '~/Components/Layout/DateTabs/DateTabs';
import FontWrapper from '~/Containers/Global/FontWrapper/FontWrapper';

import { getUserLists, updateList, setCurrent } from '~/Redux/Modules/UserLists';
import { getDrawings } from '~/Redux/Modules/Drawings';
import { PORTRAIT_IMAGE } from '~/Redux/Modules/Admin/Skins';
import { LIST_VIEW } from '~/Config/CalendarViews';
import { DrawingProvider } from '~/Components/Global/Drawing/DrawingProvider';
import mParticle, { ScreenViewEvent } from '~/Providers/mParticle';
import { getFolders } from '~/Redux/Modules/Folders';

import './Lists.scss';
import { ALIGN_TOP_CENTER } from '~/Components/Global/Drawing/DrawingDisplay';
import OnboardingFAB from '~/Components/Global/Onboarding/OnboardingFAB';

class ListsInner extends Component {
  constructor() {
    super();
    this.quill = false;
    this.editor = false;
    this.state = {
      fetched: false,
      lastUpdate: '',
      saving: false,
    };
  }

  componentDidMount = () => {
    mParticle.logEvent(new ScreenViewEvent('List Tab'));

    this.quill = createQuill(this.editor, {
      modules: {
        toolbar: '#toolbar',
        keyboard: { bindings: { noEnter: { key: 13, handler: () => true } } },
      },
    });

    this.quill.on('text-change', () => this.handleAutoSave());

    if (!this.props.fetched) this.props.loadListData();

    if (this.props.current) {
      this.handleSetEditor(this.props.currentListContents);
      this.setState({ fetched: true, lastUpdate: this.props.current.body });
    }

    this.quill.enable(!!this.props.current);

    this.interval = setInterval(this.handleAutoSave, 5000);
  };

  componentWillReceiveProps = nextProps => {
    console.log('UserList#componentWillReceiveProps', this.props, nextProps);
    if (nextProps.current && !this.state.fetched) {
      console.log('UserList#componentWillReceiveProps - nextProps.current && !fetched');
      this.handleSetEditor(nextProps.currentListContents);
      this.setState({ fetched: true, lastUpdate: nextProps.current.body });
    }

    if (nextProps.current && !this.props.current) {
      console.log('UserList#componentWillReceiveProps - nextProps.current && !props.current');
      this.handleSetEditor(nextProps.currentListContents);
      this.setState({ fetched: true, lastUpdate: nextProps.current.body });
    }

    if (nextProps.current && this.props.current && this.props.current.id !== nextProps.current.id) {
      setTimeout(() => {
        console.log('UserList#componentWillReceiveProps - changing list');
        this.handleSetEditor(nextProps.currentListContents);
        this.setState({ fetched: true, lastUpdate: nextProps.current.body });
      });
    }

    if (this.quill) {
      this.quill.enable(!!nextProps.current && !nextProps.inRecoveryMode);
    }
  };

  componentWillUnmount = () => {
    console.log('Lists#componentWillUnmount');
    this.handleAutoSave();
    if (this.interval) clearInterval(this.interval);
  };

  handleAutoSave = () => {
    const { current } = this.props;
    const currentContent = this.handleGetCurrentContents();
    console.log('handleAutoSave', currentContent, current);
    if (current && this.state.lastUpdate !== currentContent && currentContent !== '') {
      this.setState({ saving: true });
      this.handleSave(currentContent, current);
    } else {
      this.setState({ saving: false });
    }
  };

  handleSave = debounce((currentContent, list) => {
    console.log('handleSave', currentContent, list);
    if (!list.id) return;
    this.props.updateList({ ...list, body: currentContent });
    this.setState({ saving: false, lastUpdate: currentContent });
    this.props.setCurrent({ ...this.props.current, body: currentContent });
  }, 300);

  handleSaveTitle = newTitle => {
    console.log('handleSaveTitle');
    const { current } = this.props;
    this.props.updateList({ ...current, title: newTitle });
  };

  handleChangeList = e => {
    console.log('handleChangeList', e);
    if (!e) return;
    const { userLists, current } = this.props;
    this.props.updateList({
      ...current,
      body: this.handleGetCurrentContents(),
    });
    const nextList = userLists.find(ul => ul.id == e.id);
    if (nextList) {
      this.props.setCurrent(nextList);
    }
  };

  handleGetCurrentContents = () => {
    return this.quill.container.querySelector('.ql-editor').innerHTML.replace(/>\s+</g, '>&nbsp;<');
  };

  handleSetEditor = content => {
    if (!this.quill) {
      return;
    }

    const delta = this.quill.clipboard.convert(content);
    this.quill.setContents(delta);
    this.quill.history.clear();
    // this.quill.clipboard.dangerouslyPasteHTML(content);
  };

  handleCreateNew = () => {
    console.log('handleCreateNew', this.handleGetCurrentContents(), this.props.current);
    this.handleSave(this.handleGetCurrentContents(), this.props.current);
    // this.handleSetEditor("");
  };

  handleFocus = () => {
    console.log('handleFocus');
    if (this.quill) {
      this.quill.focus();
    }
  };

  renderContents = () => {
    return (
      <>
        <Toolbar
          userFolders={this.props.userFolders}
          updateList={updateList}
          saving={this.state.saving}
          parentCreate={this.handleCreateNew}
          saveTitle={this.handleSaveTitle}
          handleFocus={this.handleFocus}
          onChangeList={this.handleChangeList}
          colors={this.props.colors}
          quill={this.quill}
        />
        {this.props.inRecoveryMode && <RecoveryModeBanner />}
        <div className="drawing-provider">
          <DrawingProvider
            views={[LIST_VIEW]}
            listId={this.props.current?.id}
            alignment={ALIGN_TOP_CENTER}
            listRef={this.editor}
          >
            <FontWrapper>
              <div ref={r => (this.editor = r)} className="list-container" />
            </FontWrapper>
          </DrawingProvider>
        </div>
      </>
    );
  };

  render() {
    return (
      <div className="artful-editor">
        <SkinWrapper showButtons={false} orientation={PORTRAIT_IMAGE}>
          <DateTabs>{this.renderContents()}</DateTabs>
          {this.props.streamsReady && !this.props.onboardingComplete && <OnboardingFAB />}
        </SkinWrapper>
      </div>
    );
  }
}

ListsInner.propTypes = {
  loadListData: propTypes.func,
  updateList: propTypes.func,
  setCurrent: propTypes.func,
  userLists: propTypes.array,
  userFolders: propTypes.array,
  current: propTypes.oneOfType([propTypes.object, propTypes.bool]),
  fetched: propTypes.bool,
  currentListContents: propTypes.string,
  inRecoveryMode: propTypes.bool,
  colors: propTypes.array,
  streamsReady: propTypes.bool,
  onboardingComplete: propTypes.bool,
};

const mapStateToProps = ({
  UserLists: {
    lists,
    updates: { queue },
  },
  Folders: { folders },
  Onboarding,
  UserOptions,
}) => {
  let currentListContents = '';
  if (lists.current) {
    var updatesForList = queue.filter(({ id }) => lists.current.id === id);
    if (updatesForList.length) {
      currentListContents = updatesForList.pop().body;
    }
    currentListContents = lists.current.body;
  }

  return {
    userFolders: sortList(folders.data, 'updated_at', true),
    current: lists.current,
    userLists: lists.data,
    fetched: lists.fetched && folders.fetched,
    error: lists.error,
    isSaving: lists.isSaving,
    inRecoveryMode: lists.inRecoveryMode,
    currentListContents,
    streamsReady: Onboarding.onboarding.streamsReady,
    onboardingComplete: UserOptions.data.onboarding_complete,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadListData: () => {
      dispatch(getUserLists());
      dispatch(getFolders());
      dispatch(getDrawings('1900-01-01', '1900-01-01'));
    },
    updateList: data => dispatch(updateList(data)),
    setCurrent: data => dispatch(setCurrent(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListsInner);
